<mat-toolbar color="primary">
    <mat-toolbar-row>
        <div>
            <button *ngIf="showLoginButton" mat-icon-button (click)="onToggleSidenav()">
                <mat-icon>menu</mat-icon>
            </button>
            <button *ngIf="showBackButton" mat-icon-button routerLink="/">
                <mat-icon style="color: white;">
                    <i class="material-icons md-32">arrow_back</i>
                </mat-icon>
            </button>
        </div>

        <div *ngIf="!showBackButton">
            <a style="padding-left: 8px; color: white; font-size: 1.5rem;" [routerLink]="['/dashboard']">
                <img src="../../assets/financial-profit.png" style="width: 28px;">
            </a>
            <a style="padding-left: 8px; color: white; font-size: 1.5rem;" [routerLink]="['/dashboard']">I O U</a>
            <span *ngIf="currentTitle && currentTitle.length > 0" style="color: white; font-size: 1.5rem;"> //
                {{currentTitle}}</span>
        </div>

        <button *ngIf="showHistoryNav" mat-button class="button" routerLink="/history">
            <span style="padding-left: 8px;">History</span>
        </button>

        <span class="header-spacer"></span>
        <div>
            <button *ngIf="showLoginButton" mat-icon-button (click)="onLogout()" title="Logout">
                <mat-icon style="color: white;">
                    <i class="material-icons md-32">logout</i>
                </mat-icon>
            </button>
        </div>

    </mat-toolbar-row>
</mat-toolbar>